<div class="flex">
  <p-toast position="bottom-center" key="uploading" [baseZIndex]="5000">
    <ng-template let-message pTemplate="headless" let-closeFn="closeFn">
      <section class="bg-blue-50 text-blue-600 p-5">
        <div>
          <h3 class="title">
            {{ message.summary }}
          </h3>
          <div class="mt-1">
            <p-progressBar
              mode="indeterminate"
              [style]="{ height: '4px', marginBottom: '10px' }"
            />
            <label for=""> Uploading... </label>
          </div>
        </div>
      </section>
    </ng-template>
  </p-toast>
</div>
